export const provinces = [
  {
    slug: "ontario",
    name: "Ontario",
    abbr: "ON",
    act: "Private Security and Investigative Services Act, 2005 (PSISA)",
    regulator: "Ontario Ministry of the Solicitor General",
    note: "Every guard we deploy in Ontario holds a valid provincial security guard licence issued under the PSISA, with mandatory basic training and testing completed before their first shift.",
  },
  {
    slug: "quebec",
    name: "Quebec",
    abbr: "QC",
    act: "Private Security Act",
    regulator: "Bureau de la sécurité privée (BSP)",
    note: "Our Quebec personnel carry BSP-issued agent permits and complete the mandatory 70-hour training program required under the Private Security Act.",
  },
  {
    slug: "british-columbia",
    name: "British Columbia",
    abbr: "BC",
    act: "Security Services Act",
    regulator: "Security Programs Division, Ministry of Public Safety and Solicitor General",
    note: "Guards assigned across British Columbia are licensed under the Security Services Act and hold current Basic Security Training (BST) certification.",
  },
  {
    slug: "alberta",
    name: "Alberta",
    abbr: "AB",
    act: "Security Services and Investigators Act (SSIA)",
    regulator: "Alberta Justice and Solicitor General",
    note: "Our Alberta teams are licensed under the SSIA and complete Alberta Basic Security Training before deployment to any client site.",
  },
  {
    slug: "manitoba",
    name: "Manitoba",
    abbr: "MB",
    act: "Private Investigators and Security Guards Act",
    regulator: "Manitoba Justice",
    note: "Maze Security guards in Manitoba are licensed under the Private Investigators and Security Guards Act and vetted through provincial background checks.",
  },
  {
    slug: "saskatchewan",
    name: "Saskatchewan",
    abbr: "SK",
    act: "Private Investigators and Security Guards Act, 1997",
    regulator: "Saskatchewan Ministry of Justice",
    note: "Our Saskatchewan personnel meet the licensing and training standards set out in the Private Investigators and Security Guards Act, 1997.",
  },
  {
    slug: "nova-scotia",
    name: "Nova Scotia",
    abbr: "NS",
    act: "Private Investigators and Private Guards Act",
    regulator: "Nova Scotia Department of Justice",
    note: "Guards deployed in Nova Scotia hold provincial private guard licences issued under the Private Investigators and Private Guards Act.",
  },
  {
    slug: "new-brunswick",
    name: "New Brunswick",
    abbr: "NB",
    act: "Private Investigators and Security Services Act",
    regulator: "New Brunswick Department of Justice and Public Safety",
    note: "Our New Brunswick guards are licensed under the Private Investigators and Security Services Act and screened before assignment.",
  },
  {
    slug: "newfoundland-and-labrador",
    name: "Newfoundland and Labrador",
    abbr: "NL",
    act: "Private Investigators and Security Services Act",
    regulator: "Service NL",
    note: "Personnel serving Newfoundland and Labrador are licensed under the provincial Private Investigators and Security Services Act.",
  },
  {
    slug: "prince-edward-island",
    name: "Prince Edward Island",
    abbr: "PE",
    act: "Private Investigators and Security Guards Act",
    regulator: "PEI Department of Justice and Public Safety",
    note: "Our Prince Edward Island guards meet the licensing requirements of the provincial Private Investigators and Security Guards Act.",
  },
  {
    slug: "northwest-territories",
    name: "Northwest Territories",
    abbr: "NT",
    act: "Private Investigators and Security Guards Act",
    regulator: "NWT Department of Justice",
    note: "Guards assigned in the Northwest Territories hold territorial licences and are prepared for remote-site and industrial deployments.",
  },
  {
    slug: "yukon",
    name: "Yukon",
    abbr: "YT",
    act: "Private Investigators and Security Guards Act",
    regulator: "Yukon Department of Community Services",
    note: "Our Yukon personnel are licensed territorially and experienced with mining, remote camp and northern logistics environments.",
  },
  {
    slug: "nunavut",
    name: "Nunavut",
    abbr: "NU",
    act: "Private Investigators and Security Guards Act",
    regulator: "Nunavut Department of Justice",
    note: "Guards serving Nunavut communities hold the required territorial licensing and are briefed on northern and remote-site operations.",
  },
];

export const provinceBySlug = Object.fromEntries(provinces.map((p) => [p.slug, p]));
